// extracted by mini-css-extract-plugin
export var borderRadius = "_bs-4";
export var large = "_bs-3";
export var logoContainer = "_bs-0";
export var nameLogo = "_bs-2";
export var small = "_bs-1";